// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__39Vo7","alertIcon":"ConfirmModal_alertIcon__3sPSf"};